import React from 'react'

const DateIconSvg = props => <svg
  width="5"
  height="11"
  viewBox="0 0 5 11"
  fill="none"
>
  <path
    d="M1.06006 29.7935H0L3.85938 19.7578H4.91309L1.06006 29.7935Z"
    transform="translate(0 -19)"
    fill="#333333"
  />
</svg>

export default DateIconSvg



// WEBPACK FOOTER //
// ./src/modules/DateControl/DateIconSvg.js